import { TooltipCode } from 'areas/shared/consts';

const IncorporationArticles = { 
    code: "IncorporationArticles", 
    visible: true,
    description: "Articles of Incorporation (Amendments, if applicable)",
    tooltipCode: TooltipCode.ARTICLE.INCARTICLESUPLOAD
};

const IncorporationCertificate = { 
    code: "IncorporationCertificate", 
    visible: true,
    description: "Certificate of Incorporation",
    tooltipCode: TooltipCode.ARTICLE.INCCERTIFICATEUPLOAD
};

const CorporateByLaws = { 
    code: "CorporateByLaws", 
    visible: true,
    description: "Corporate By-Laws",
    tooltipCode: TooltipCode.ARTICLE.CORPLAWSUPLOAD
};

const ForeignEntityCertificate = {
    code: "ForeignEntityCertificate", 
    visible: true,
    description: "Foreign Entity Certificate",
    tooltipCode: TooltipCode.ARTICLE.FOREIGNENTCERUPLOAD
};

const OfficersElectedMinutes = { 
    code: "OfficersElectedMinutes", 
    visible: true,
    description: "Minutes of the last meeting where officers were elected",
    tooltipCode: TooltipCode.ARTICLE.MINUTESLASTMEETINGUPLOAD
};

const FirstBoardMeetingMinutes = { 
    code: "FirstBoardMeetingMinutes", 
    visible: true,
    description: "Minutes of 1st Organizational Board Meeting (If business is less than 2 years old)",
    tooltipCode: TooltipCode.ARTICLE.FIRSTBDMEETINGMINUPLOAD
};

const MostRecentMeetingMinutes = { 
    code: "MostRecentMeetingMinutes", 
    visible: true,
    description: "Most recent Minutes of organizational meeting or minutes of the meeting",
    tooltipCode: TooltipCode.ARTICLE.MOSTREMEETINGMINUPLOAD
};

const CapitalContributionProof = { 
    code: "CapitalContributionProof", 
    visible: true,
    description: "Proof of Capital Contribution by majority owner at time of company start or owner's acquisition",
    tooltipCode: TooltipCode.ARTICLE.CAPITALCONTRIBUPLOAD
};

const StockPurchaseProof = { 
    code: "StockPurchaseProof", 
    visible: true,
    description: "Proof of Stock Purchase",
    tooltipCode: TooltipCode.ARTICLE.STOCKPURUPLOAD
};

const CorporateStockCertificates = { 
    code: "CorporateStockCertificates", 
    visible: true,
    description: "Corporate Stock Certificates",
    tooltipCode: TooltipCode.ARTICLE.CORPORATESTOCKCERUPLOAD
};

const CorporateStockLedger = {
    code: "CorporateStockLedger",
    visible: true,
    description: "Current Stock Ledger",
    tooltipCode: TooltipCode.ARTICLE.CORPORATESTOCKLEDUPLOAD
};

const OperationalAgreement = {
    code: "OperationalAgreement",
    visible: false,
    description: ""
};

const BuyOutRights = {
    code: "BuyOutRights",
    visible: false,
    description: ""
};

const LimitedPartnershipCertificate = {
    code: "LimitedPartnershipCertificate",
    visible: false,
    description: ""
};

const LimitedPartnershipDocuments = {
    code: "LimitedPartnershipDocuments",
    visible: false,
    description: ""
};

const PartnershipAgreements = {
    code: "PartnershipAgreements",
    visible: false,
    description: ""
};

const ProfitSharing = {
    code: "ProfitSharing",
    visible: false,
    description: ""
};

const ThirdPartyAgreements = {
    code: "ThirdPartyAgreements",
    visible: false,
    description: ""
};

export default {
    IncorporationArticles,
    IncorporationCertificate,
    CorporateByLaws,
    ForeignEntityCertificate,
    OfficersElectedMinutes,
    FirstBoardMeetingMinutes,
    MostRecentMeetingMinutes,
    CapitalContributionProof,
    StockPurchaseProof,
    CorporateStockCertificates,
    CorporateStockLedger,
    OperationalAgreement,
    BuyOutRights,
    LimitedPartnershipCertificate,
    LimitedPartnershipDocuments,
    PartnershipAgreements,
    ProfitSharing,
    ThirdPartyAgreements
};


// WEBPACK FOOTER //
// ./src/areas/certification/steps/articles/UploadsConfig/CorporationsConfig.js